import React, {useEffect, useState} from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet";
import { Box, Tabs as MuiTabs, Tab as MuiTab, Typography as MuiTypography } from "@material-ui/core";
import { spacing } from "@material-ui/system";
import {useHistory, useLocation} from "react-router-dom";

import { useAuth } from "../../../context/auth";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import {makeStyles} from "@material-ui/core/styles";
import {useGlobalState} from "../../../context/global_state";
import {getSchoolScoreTabs} from "./components/SchoolScoreTabs.def";
import {useSchoolRubricData} from "./hooks/useSchoolRubricData";
import {getSchools} from "../../../services/school.service";

const Tabs = styled(MuiTabs)(spacing);
const Tab = styled(MuiTab)(spacing);
const Typography = styled(MuiTypography)(spacing);

function TabPanel({ children, value, index }) {
    return value === index && <Box py={3}>{children}</Box>;
}

const useStyles = makeStyles(theme => ({
    root:{
        backgroundColor: "grey",
        color: theme.palette.secondary.contrastText,
        margin: "0px 1px 0px 1px",
        padding: "0px 0px 0px 0px",
        minWidth: "auto",
        minInlineSize: "auto",

        "&.Mui-selected": {
            backgroundColor: theme.sidebar.background,
            color: theme.palette.secondary.contrastText,

        }
    },

    indicator: {
        backgroundColor: "primary",
        height: "100%",
        opacity: "0%",
        width: "100%",
    },

    link: {

    }
}));

function SchoolScore() {
    const { authUser } = useAuth();
    const location = useLocation();
    const { settings } = useGlobalState();
    const selectedReport = settings.selected_report;
    const history = useHistory();
    const { pathname } = location;
    const basePath = `/${pathname.split('/')[1]}/school/school_score`;
    const classes = useStyles();
    const [school, setSchool] = useState('');
    const {
        loading,
        processedRubricSchool,
        assessIndicators
    } = useSchoolRubricData(authUser.org_code, selectedReport, school, authUser.org_obj.org_country);
    const [selectedCategory, setSelectedCategory] = useState( "");
    const [monthRange, setMonthRange] = useState([null, null]);
    const tabDefs = getSchoolScoreTabs(
        processedRubricSchool,
        assessIndicators,
        selectedCategory,
        setSelectedCategory,
        monthRange,
        setMonthRange
    );
    const currentTabIdx = tabDefs.findIndex(tab =>
        pathname.startsWith(`${basePath}/${tab.path}`)
    );

    const handleTabChange = (e, idx) => {
        history.push(`${basePath}/${tabDefs[idx].path}`);
    };

    useEffect(() => {
        if (currentTabIdx === -1) {
            history.replace(`${basePath}/overall`);
        }
    }, [pathname]);

    useEffect(() => {
        const loadSchoolList = async (page = 0, rowsPerPage = 10, order = "asc", orderBy = undefined) => {
            try {
                const result = await getSchools(authUser.org_code, selectedReport, page, rowsPerPage, order, orderBy);
                if (result.data) {
                    console.log('Result School List --> ', result.data);
                    setSchool(result.data.data[0]?.school_name);
                }
            } catch (e) {
                console.log("Some error occurred while fetching progress data");
            }
        };
        // Call with default params or adjust as needed
        loadSchoolList();
    }, []);

    return (
        <React.Fragment>
            <Helmet title={"School Score"} />
            <Box width="100%" py={4}>
                <Tabs
                    value={currentTabIdx === -1 ? 0 : currentTabIdx}
                    onChange={handleTabChange}
                    TabIndicatorProps={{ className: classes.indicator }}
                    style={{paddingLeft: "30px", paddingRight: "30px"}}
                    centered
                    variant="fullWidth"
                    scrollButtons="auto"
                    aria-label="styled tabs example"
                >
                    {tabDefs.map(tabDef => (
                        <Tab key={tabDef.key} label={tabDef.label} classes={{root: classes.root}}  style={{ fontWeight: "bold", fontSize: 16, minWidth: 200 }}/>
                    ))}
                </Tabs>
                <Box mt={3}>
                    {tabDefs.map((tabDef, idx) => (
                        <TabPanel key={tabDef.key} value={currentTabIdx} index={idx}>
                            {tabDef.component}
                        </TabPanel>
                    ))}
                </Box>
            </Box>
            <LoaderWithBackDrop loading={loading} />
        </React.Fragment>
    );
}

export default SchoolScore;